/**
 * Public API for the auth feature.
 * Other modules import from this file only.
 */
export { AuthProvider, hasPersistedAuthSession } from './context/AuthProvider';
export { useAuth } from './hooks/useAuth';
export { AuthModalProvider, openAuthModal, closeAuthModal } from './components/AuthModal/AuthModalProvider';
export { default as EmailVerificationModal } from './components/EmailVerification';
export { default as PhoneChangeModal } from './components/PhoneChange';
export { AUTH_ERROR_CODE, AUTH_STEP, OTP_LENGTH } from './constants';
